import { variables as sharedJSVariables } from "@pg-flex/shared-js/theme/VariablesStyle";
import { totalColors } from "@pg-flex/shared-js/theme/totalColors";
import Color from "color";

import { isStaging } from "@/pv-utils/isStaging";

const primaryColor = isStaging ? "var(--total-blue)" : "#ED0000";

// Expose variables as JS object.
export const variables = {
  // Reuse SharedJS's variables
  ...sharedJSVariables,

  // PV overwrites & new values
  "text-font": "'Roboto', sans-serif",
  "title-font": "'Varela Round', sans-serif",
  "subtext-1": "var(--total-pearl)",
  "primary-background-color": "#EDF3F5",
  "primary-button-disabled-color": "#B7CBD3",
  "success-color": "var(--total-lime)",
  "button-switch-background": "#f7f9fa",
  "table-border": "1px solid #eceef3",
  "modal-z-index": 1,
  "popover-overlay-z-index": 2,
  "popover-content-z-index": 3,
  "toast-z-index": 4,
  "tooltip-opaque-background-color": "var(--total-pearl)",
  "tooltip-background-color": Color(totalColors["total-pearl"])
    .alpha(0.8)
    .hexa(),
  "unselected-pin-background": Color(totalColors["total-pearl"])
    .alpha(0.36)
    .hexa(),
  "unselected-pin-border": "#B7CBD3",
  // Toasts
  "toast-success-background-color": "#ebfbf5",
  "toast-success-icon-color": "#35d39d",

  // PV overwrites for staging env
  "primary-color": primaryColor,
  "active-button-switch-background": isStaging
    ? `linear-gradient(129deg, ${Color(totalColors["total-blue"])
        .rotate(26)
        .hex()} 0%, ${primaryColor} 100%) 0% 0%`
    : `linear-gradient(129deg, ${Color(primaryColor)
        .rotate(26)
        .hex()} 0%, ${primaryColor} 100%) 0% 0%`,

  "selected-pin-background": Color(
    isStaging ? totalColors["total-blue"] : primaryColor
  )
    .alpha(0.24)
    .hexa(),
  "selected-pin-border": primaryColor,
};

export const toastColors = {
  success: "var(--total-lime)",
  info: "#4486f6",
  error: "#AC0929",
};

export const plotVariables = {
  "grid-color": "#d1dedf",
};
